import { Provider } from "jotai/react";
import { createStore } from "jotai/vanilla";
import { FC } from "react";
import { Outlet } from "react-router-dom";

import { Background } from "@/components/Layout/Background/Background";
import { WelcomeScreenFooter } from "@/components/Layout/WelcomeScreenFooter/WelcomeScreenFooter";
import { WelcomeHeader } from "@/components/Welcome/WelcomeHeader/WelcomeHeader";

export const authenticatorStore = createStore();

export const AuthenticatorLayout: FC = () => (
  <Provider store={authenticatorStore}>
    <Background>
      <WelcomeHeader />
      <div className="mt-16 flex md:mt-40 2xl:mt-4">
        <div className="m-4 mt-14 flex h-fit w-fit max-w-4xl flex-col items-center justify-center bg-white p-10 md:m-auto md:mt-auto">
          <Outlet />
        </div>
      </div>
      <WelcomeScreenFooter />
    </Background>
  </Provider>
);
